/**
 * RegionalSettingsSection Component
 * 
 * Regional configuration including:
 * - Language selection
 * - Timezone selection
 * - Currency selection
 */

import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { IoMdArrowDropdown } from 'react-icons/io';
import type { LanguageOption, TimezoneOption, MonedaOption } from '../../components/utils/utils';
import './RegionalSettingsSection.scss';

interface RegionalSettingsSectionProps {
  idioma: string;
  zonaHoraria: string;
  moneda: string;
  languages: LanguageOption[];
  timezones: TimezoneOption[];
  monedas: MonedaOption[];
  onIdiomaChange: (value: string) => void;
  onZonaHorariaChange: (value: string) => void;
  onMonedaChange: (value: string) => void;
}

const RegionalSettingsSection: React.FC<RegionalSettingsSectionProps> = ({
  idioma,
  zonaHoraria,
  moneda,
  languages,
  timezones,
  monedas,
  onIdiomaChange,
  onZonaHorariaChange,
  onMonedaChange,
}) => {
  return (
    <div className="settings-card">
      <h4>Ajustes de región</h4>
      
      {/* Language */}
      <div className="form-field">
        <label className="field-label">Idioma</label>
        <Dropdown>
          <Dropdown.Toggle className="modern-dropdown">
            {languages.find((lang) => lang.id.toString() === idioma)?.label ||
              'Seleccionar Idioma'} <IoMdArrowDropdown />
          </Dropdown.Toggle>
          <Dropdown.Menu className="modern-dropdown-menu">
            {languages.map((lang) => (
              <Dropdown.Item 
                key={lang.id} 
                onClick={() => onIdiomaChange(lang.id.toString())}
                active={idioma === lang.id.toString()}
              >
                {lang.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Timezone */}
      <div className="form-field">
        <label className="field-label">Zona horaria</label>
        <Dropdown>
          <Dropdown.Toggle className="modern-dropdown">
            {timezones.find((zone) => zone.id.toString() === zonaHoraria)?.label ||
              'Seleccionar Zona Horaria'} <IoMdArrowDropdown />
          </Dropdown.Toggle>
          <Dropdown.Menu className="modern-dropdown-menu">
            {timezones.map((zone) => (
              <Dropdown.Item
                key={zone.id}
                onClick={() => onZonaHorariaChange(zone.id.toString())}
                active={zonaHoraria === zone.id.toString()}
              >
                {zone.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Currency */}
      <div className="form-field">
        <label className="field-label">Moneda</label>
        <Dropdown>
          <Dropdown.Toggle className="modern-dropdown">
            {monedas.find((monedaItem) => monedaItem.id.toString() === moneda)?.label ||
              'Seleccionar Moneda'} <IoMdArrowDropdown />
          </Dropdown.Toggle>
          <Dropdown.Menu className="modern-dropdown-menu">
            {monedas.map((monedaItem) => (
              <Dropdown.Item
                key={monedaItem.id}
                onClick={() => onMonedaChange(monedaItem.id.toString())}
                active={moneda === monedaItem.id.toString()}
              >
                {monedaItem.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default RegionalSettingsSection;
